import { Particle } from "../particle";
import { colorLerp, constant, easeOut, lerp, linearMotion, randomBetween } from "../interpolation";

/**
 * Yellow-brown stink wisps (base tone #885a14) drifting up from bile.
 * Full size marks an emitting slug shell; `sizeScale` < 1 gives the
 * subtler haze used by bile puddles.
 */
export class BileSmokeParticle extends Particle {
	static readonly emitIntervalMs = 180;
	static readonly emitIntervalSmallMs = 380;

	constructor(originX: number, originY: number, sizeScale: number = 1) {
		const ttl = randomBetween(800, 1200);

		const vx = randomBetween(-0.3, 0.3);
		const vy = randomBetween(-2.5, -0.3);

		const startSize = randomBetween(0.35, 0.45) * sizeScale;
		const endSize = randomBetween(0.7, 1.1) * sizeScale;

		const darkBile = {
			r: randomBetween(110, 145),
			g: randomBetween(70, 100),
			b: randomBetween(10, 35),
		};
		const lightBile = {
			r: randomBetween(165, 195),
			g: randomBetween(135, 160),
			b: randomBetween(75, 105),
		};

		const ox = originX + randomBetween(-0.3, 0.3);
		const oy = originY + randomBetween(-0.4, -0.2);

		super(ox, oy, {
			ttl,
			size: lerp(startSize, endSize),
			opacity: easeOut(0.7, 0.1),
			color: colorLerp(darkBile, lightBile),
			rotation: constant(0),
			position: linearMotion(vx, vy),
		});
	}
}
